import { generateClassName } from '@klv/shared/utils/functions';

import BaseGrid from './styles';
import * as styles from './styles/grid.module.css';

import type { IGrid } from './types';

const Grid = ({
  children,
  innerRef,
  ...rest
}: IGrid) => (
  <BaseGrid ref={innerRef} {...rest}>{children}</BaseGrid>
);

export const ModulesGrid = ({
  children,
  className,
  innerRef,
  ...rest
}: IGrid) => (
  <div className={generateClassName([className, styles.grid])} ref={innerRef} {...rest}>{children}</div>
);

export default Grid;
